/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useCallback, useEffect, useState } from "react";

import { faCommentAlt as faCommentAltRegular } from "@fortawesome/free-regular-svg-icons";
import { faCommentAlt as faCommentAltSolid } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useChat } from "~/hooks/chat";

import { getChatsService } from "~/services/deadpool";
import OfflineChat from "~/components/OfflineChat";

import ConversationsTable from "./ConversationsTable";
import Help from "./Help";
import "./styles.scss";

type ChatInternalProps = {
  showOffChat: boolean;
  showHelp: boolean;
  setShowOffChat: (value: boolean) => void;
  setShowHelp: (value: boolean) => void;
};

const ChatInternal: React.FC<ChatInternalProps> = ({
  showOffChat,
  showHelp,
  setShowOffChat,
  setShowHelp,
}) => {
  const { user, setKeyData, notifications } = useChat();

  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(true);
  const [chats, setChats] = useState<any>([]);

  const getChats = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getChatsService({
        owner_uuid: user?.uuid,
        open,
      });

      setChats(data);

      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }, [user, open]);

  useEffect(() => {
    if (user) getChats();
  }, [getChats, user]);

  const hasNot = useCallback(
    chat => {
      return notifications?.find(
        not =>
          not.chat_id === chat &&
          not.status === 0 &&
          not.user_uuid === user?.uuid,
      );
    },
    [notifications, user],
  );

  const ticketArea = useCallback(team => {
    switch (team) {
      case 1:
        return "Suporte";
      case 2:
        return "Financeiro";
      case 3:
        return "Comercial";
      case 4:
        return "Migração";
      case 5:
        return "Spam";
      case 6:
        return "Insights";
      case 7:
        return "Whitelabel";
      case 8:
      case 0:
        return "Outros";
      default:
        return "Suporte";
    }
  }, []);

  return showOffChat && !showHelp ? (
    <OfflineChat />
  ) : (
    <div className="defaultContainer">
      <div style={{ minHeight: "391px" }}>
        {showHelp ? (
          <Help showOffChat={showOffChat} setShowOffChat={setShowOffChat} />
        ) : (
          <>
            {!showOffChat && !showHelp && (
              <>
                <div className="states">
                  <button
                    onClick={() => setOpen(true)}
                    className={!open ? "finished" : ""}
                    type="button"
                  >
                    <FontAwesomeIcon icon={faCommentAltRegular} />
                    <span>Em andamento</span>
                  </button>
                  <button
                    onClick={() => setOpen(false)}
                    className={open ? "finished" : ""}
                    type="button"
                  >
                    <FontAwesomeIcon icon={faCommentAltSolid} />
                    <span>Finalizadas</span>
                  </button>
                </div>
                {chats.length === 0 ? (
                  <div
                    style={{
                      minHeight: "346px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="emptyConversations">
                      <img
                        src="https://chat.cloudez.io/noneChats.svg"
                        alt="nenhum atendimento"
                      />
                      <div className="text">
                        <span className="empty">{`Nenhum atendimento ${
                          open ? "aberto" : "finalizado"
                        }`}</span>
                        <span>
                          Se precisar de nossa ajuda só clicar no botão abaixo
                        </span>
                      </div>
                    </div>
                    <div className="newChat">
                      <button
                        style={{ width: "255px" }}
                        onClick={() => setShowHelp(true)}
                        type="button"
                      >
                        NOVO ATENDIMENTO
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      minHeight: "346px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      gap: "4px",
                    }}
                  >
                    <ConversationsTable
                      setKeyData={setKeyData}
                      chats={chats}
                      hasNot={hasNot}
                      ticketArea={ticketArea}
                      loading={loading}
                    />
                    <div className="newChat">
                      <button
                        style={{ width: "255px" }}
                        onClick={() => setShowHelp(true)}
                        type="button"
                      >
                        NOVO ATENDIMENTO
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
      {!showOffChat && (
        <footer>
          <span>
            ou acesse a nossa{" "}
            <a href="https://help.cloudez.io/" rel="noreferrer" target="_blank">
              Base de Conhecimento
            </a>
          </span>
        </footer>
      )}
    </div>
  );
};

export default ChatInternal;
